module.exports = __webpack_public_path__ + "static/media/PROD_E1.38f4d36b.png";